export default __webpack_public_path__ + "static/media/card-1.c9eaa737.webp";